module.exports = __webpack_public_path__ + "img/icon-compte-light-red.c7fa4be8.svg";